import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';

export interface Metric {
}

export class MetricService extends AuthenticatedService {
  public list = async (page: number = 1): Promise<IHttpResponse<Page<Metric>>> => {
    const metrics = await this.getAuth<Page<Metric>>(
      `metrics?page=${page}`,
    );

    return metrics;
  }
}
